export class FlowStateService {

    /* @ngInject */
    constructor() {
        this.reason = null;
        this.installationUserId = null;
        this.installationSessionId = null;
        this.addNfcChip = true;
    }

    setLoginReason(loginReason) {
        this.reason = loginReason;
    }

    getInstallationUserId() {
        return this.installationUserId;
    }

    setInstallationUserId(installationUserId) {
        this.installationUserId = installationUserId;
    }

    getInstallationSessionId() {
        return this.installationSessionId;
    }

    getFlowState() {
        return {
            reason: this.reason,
            installationUserId: this.installationUserId,
            installationSessionId: this.installationSessionId,
            addNfcChip: this.addNfcChip
        };
    }

    getAddNfcChip() {
        return this.addNfcChip;
    }

    setAddNfcChip(addNfcChip) {
        this.addNfcChip = addNfcChip;
    }

    update(data) {
        this.installationUserId = data.installationUserId;
        this.installationSessionId = data.installationSessionId;
    }

    clear() {
        this.reason = null;
        this.installationUserId = null;
        this.installationSessionId = null;
        this.addNfcChip = true;
    }
}
